import {
  MenuGroup,
  MenuItem,
  Menu,
  MenuButton,
  MenuList,
  Box,
  IconButton,
  UserCircleIcon,
} from '@cdl/heartbeat-react';
import React from 'react';
import { useSelector } from 'react-redux';
import { userSelector } from '../selectors/auth.selectors';
import { useLogout } from 'shared/hooks/useLogout';

export const Logout: React.FC = () => {
  const user = useSelector(userSelector);
  const logout = useLogout();

  return (
    <>
      <Box mx='m'>
        <Menu>
          {({ isOpen }) => (
            <>
              <IconButton
                as={MenuButton}
                pointerEvents='auto'
                variant='tertiary'
                aria-label='logout'
                size='sm'
                isActive={isOpen}
                icon={<UserCircleIcon fontSize='m' />}
              />
              <MenuList>
                <MenuGroup title={user?.email}>
                  <MenuItem onClick={logout}>Disconnect</MenuItem>
                </MenuGroup>
              </MenuList>
            </>
          )}
        </Menu>
      </Box>
    </>
  );
};
